import { Linear, TimelineMax, TweenMax } from "gsap";
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../vendor_core/core/src/const/SoundVars";
import AutoplayModel from "../../../vendor_core/core/src/model/AutoplayModel";
import BetModel from "../../../vendor_core/core/src/model/BetModel";
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { State } from "../../../vendor_core/core/src/states/State";
import UIController from "../../../vendor_core/core/src/ui/UIController";
import { UIModes } from "../../../vendor_core/core/src/ui/UIStates";
import BangUp from '../../../vendor_core/core/src/utils/BangUp';
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import SceneView from '../../../vendor_core/core/src/views/SceneView';
import VendorModel from '../../../vendor_core/server/model/VendorModel';
import RelaxPOSTMessageController from '../../../vendor_core/server/RelaxPOSTMessageController';
import BBModel from '../model/BBModel';
import BBAnimationsHelper from "../utils/BBAnimationsHelper";
import BBUtils from '../utils/utils';
import BBReelGroup from '../view/BBReelGroup';


export default class BBExitFreespinState extends State {
    private animScene: SceneView;
    private bigwinTweens: TweenMax[] = [];
    public enter() {
        super.enter();
        GameModel.shouldUpdateBalance = true;
        BBModel.spinStartTime = 0;
        let reelGroup = ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .getSubView("ReelGroup") as BBReelGroup;

        reelGroup.hideLinesAndInfo(true);
        TweenMax.delayedCall(1, () => {
            this.showPopup();
        });
        CommandManager.execute(Commands.UPDATE_WIN);
    }

    private showPopup = () => {
        const scene = ViewManager.getLayer(DefaultLayers.Popups).setScene("freespinssummary");
        this.animScene = ViewManager.getLayer("CloudAnim").setScene("open");
        const winMoney = scene.sceneMoneyFields.get("value");
        let currentBangup = new BangUp();
        let bangupEndVal = SpinModel.freespinWinnings;
        let bangUpVal = 0;
        let duration = 7.684;
        let endDelay = 3;

        SoundController.stopMusic();
        SoundController.playMusic('bigWinMusic', 0);


        if (this.isBigWin()) {
            const maxWinLevel = this.getHighestWinLevel();

            // First get the total duration of bangup
            const durationsByWin = GameModel.gameConfig.bigWinMusicStamps;

            duration = durationsByWin[maxWinLevel];
        }

        currentBangup.startBangup(bangUpVal, bangupEndVal, duration, { ease: Linear.easeNone }, (val) => {
            bangUpVal = val;
            winMoney.value = bangUpVal;
        }, () => {
            this.bigwinTweens.forEach(tween => {
                if (tween) {
                    tween.kill();
                }
            })
            SoundController.stopMusic();
            SoundController.playSound('bigwin_start_lv1');
            SoundController.playMusic(SoundVars.MUSIC_MAIN);
            // SoundController.fadeMusic(0, 1, 1.917);

            TweenMax.delayedCall(endDelay, () => {
                const anim = this.animScene.spineAnimations.get("popup_win");
                anim.playAsync("outro_big_win").then(() => {
                    ViewManager.getLayer("CloudAnim").clear();
                    SoundController.playSound('tornado');
                    RelaxPOSTMessageController.featureFinished();
                    BBAnimationsHelper.playTornadoAnimations(() => {
                        ViewManager.getLayer("Tornado").clear();

                        this.closePopup();
                    })
                });
                ViewManager.getLayer(DefaultLayers.Popups).clear();

            })
        });

        scene.once(PointerEvents.DOWN, () => {
            currentBangup.clearBangup();
            this.bigwinTweens.forEach(tween => {
                if (tween) {
                    tween.kill();
                }
            })
        })

        scene.interactive = true;
    }

    private isBigWin() {
        return SpinModel.freespinWinnings / BetModel.totalBet >= GameModel.gameConfig.bigWinRatioLevels[0];
    }

    private getHighestWinLevel() {
        let maxBigWinLevel = 0;
        const bigWinRatios = GameModel.gameConfig.bigWinRatioLevels;
        const currentWinRatio = SpinModel.freespinWinnings / BetModel.totalBet;
        for (let i = bigWinRatios.length - 1; i > 0; i--) {
            if (bigWinRatios[i] <= currentWinRatio) {
                maxBigWinLevel = i;
                break;
            }
        }

        return maxBigWinLevel;
    }

    private closePopup = () => {
        SpinModel.accumulatedWin = SpinModel.freespinWinnings;
        this.animScene = null;
        ViewManager.getLayer(DefaultLayers.Banners).setScene();
        let bgLayer = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
        bgLayer.spineAnimations.get("bg").play();

        SpinModel.setReelSetIndex(0);
        SpinModel.exitFreespins();
        BetModel.clearStartBalance();
        if (!VendorModel.inFreeGames) {
            AutoplayModel.setAutoSpin(0);
            UIController.setMode(UIModes.DEFAULT);
        } else {
            UIController.setMode(UIModes.PROMOTION_SPINS);
        }
        // SoundController.playMusic(SoundVars.MUSIC_MAIN);
        BBUtils.repositionLogo();

        this.exit();
    }
}
